const i18n_fields = {
  EN: [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
    { key: 'is_alive', label: 'Usage status', sortable: false },
    { key: 'hash', label: 'Hash', sortable: false, thStyle: 'width: 40%' },
    { key: 'cause', label: 'Description', sortable: false },
    { key: 'created_at', label: 'Date', sortable: false },
    // { key: 'func', label: 'More', sortable: false, thStyle: 'width: 10%' },
  ],
  KO: [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
    { key: 'is_alive', label: '사용 여부', sortable: false },
    { key: 'hash', label: '해시', sortable: false, thStyle: 'width: 40%' },
    { key: 'cause', label: '설명', sortable: false },
    { key: 'created_at', label: '일시', sortable: false },
    // { key: 'func', label: '더 보기', sortable: false, thStyle: 'width: 10%' },
  ],
  JP: [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
    { key: 'is_alive', label: '利用状況', sortable: false },
    { key: 'hash', label: 'ハッシュ', sortable: false, thStyle: 'width: 40%' },
    { key: 'cause', label: '説明', sortable: false },
    { key: 'created_at', label: '日付', sortable: false },
    // { key: 'func', label: 'More', sortable: false, thStyle: 'width: 10%' },
  ]
}

const fields = { i18n_fields }

export default fields